import { Referral, ReferralStatus } from 'src/constants';
import {
  REFERRAL_PAID_CREDITS,
  REFERRAL_SIGNUP_CREDITS,
} from 'src/constants/referralConsts';

// Pending is the old program's "signed up, not paid yet", so it counts as a
// signup alongside the new statuses.
const SIGNED_UP_STATUSES: ReadonlySet<ReferralStatus> = new Set([
  ReferralStatus.In_Trial,
  ReferralStatus.Signed_Up,
  ReferralStatus.Converted,
]);

export type ReferralSummary = {
  signedUp: number;
  converted: number;
  creditsEarned: number;
};

// `amount` on a referral is the legacy cash payout, so credits come from the
// status and the fixed grants instead.
export const getReferralCredits = (referral: Referral): number => {
  if (!SIGNED_UP_STATUSES.has(referral.status)) return 0;
  return referral.status === ReferralStatus.Converted
    ? REFERRAL_SIGNUP_CREDITS + REFERRAL_PAID_CREDITS
    : REFERRAL_SIGNUP_CREDITS;
};

export const getReferralSummary = (referrals: Referral[]): ReferralSummary =>
  referrals.reduce<ReferralSummary>(
    (summary, referral) => {
      if (!SIGNED_UP_STATUSES.has(referral.status)) {
        return summary;
      }
      return {
        signedUp: summary.signedUp + 1,
        converted:
          summary.converted +
          (referral.status === ReferralStatus.Converted ? 1 : 0),
        creditsEarned: summary.creditsEarned + getReferralCredits(referral),
      };
    },
    { signedUp: 0, converted: 0, creditsEarned: 0 },
  );

/** Invited rows have no workspace yet, so the invitee's email stands in. */
export const getReferralCompanyName = (referral: Referral): string =>
  referral.onboardedUserName || referral.onboardedUserEmail || referral.id;

/** Only a referral that signed up has earned anything to show. */
export const hasEarnedCredits = (referral: Referral): boolean =>
  SIGNED_UP_STATUSES.has(referral.status);
